module.exports = __webpack_public_path__ + "assets/img/vtuber-left3.a961441c.png";